// src/admin/hooks/useAdmin.ts
// Reads a single admin_users row by id. Detail-screen hook — mirrors the
// column projection from useAdmins so AdminRow is interchangeable.
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@admin/lib/supabase';
import type { AdminRow } from './useAdmins';

export function useAdmin(id: string | undefined) {
  return useQuery<AdminRow | null>({
    queryKey: ['admin', id],
    enabled: !!id,
    queryFn: async () => {
      if (!id) return null;
      const { data, error } = await supabase
        .from('admin_users')
        .select(
          'id, email, display_name, role, is_readonly, is_active, last_login_at, totp_enrolled_at',
        )
        .eq('id', id)
        .single();
      if (error) throw error;
      return data as AdminRow;
    },
  });
}
